import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'
import {
  removeEnroll,
  setEnrollDetail,
  setFormNextButtonDisabled,
  setReduxValue,
} from '.'
import { handleFormInput, handleFormNextStep, handleStep2Button } from './event'
import {
  setUploadDocument,
  setClearFile,
  setData,
} from 'src/redux/slices/document'
import {
  getRegisterDocument,
  uploadRegisterDocument,
} from 'src/services/document'
// import { getPrefixENFromTH } from '../../../../utils/lib'

export const listenerMiddlewareEnroll = createListenerMiddleware()

listenerMiddlewareEnroll.startListening({
  matcher: isAnyOf(
    setEnrollDetail,
    setUploadDocument, // ✅ อัปโหลดไฟล์
    setClearFile, // ✅ เคลียร์ไฟล์
    setData, // ✅ เซตข้อมูลเอกสาร
    setReduxValue, // ✅ ติ๊ก checkbox consent (ถ้าอยู่ใน currentState)
    getRegisterDocument.fulfilled,
    uploadRegisterDocument.fulfilled
  ),
  effect: async (action, listenerApi) => {
    const { index, obj } = action.payload
    const originalState = listenerApi.getOriginalState().classEnroll
    const currentState = listenerApi.getState().classEnroll
    const documentState = listenerApi.getState().document

    const enrollIndex = typeof index !== 'undefined' ? 0 : 0

    if (obj === 'idCardNo' || obj === 'mobileNo') {
      listenerApi.dispatch(
        setReduxValue({ index: 'duplicatedError', value: [] })
      )
    }

    await handleFormInput(
      currentState,
      originalState,
      documentState,
      enrollIndex,
      listenerApi
    )
    await handleFormNextStep(
      currentState,
      originalState,
      enrollIndex,
      listenerApi
    )
  },
})

// listenerMiddlewareEnroll.startListening({
//   actionCreator: setEnrollDetail,
//   effect: async (action, listenerApi) => {
//     const { index, obj } = action.payload
//     if (obj == 'prefixTH') {
//       const { prefixTH } = listenerApi.getState().classEnroll.enroll[index]
//       const prefix = getPrefixENFromTH(prefixTH)
//       listenerApi.dispatch(
//         setEnrollDetail({ index, obj: 'prefix', value: prefix })
//       )
//     }
//     if (obj == 'prefix') {
//       const { prefix } = listenerApi.getState().classEnroll.enroll[index]
//       const prefixTH = getPrefixENFromTH(prefix, true)
//       listenerApi.dispatch(
//         setEnrollDetail({ index, obj: 'prefixTH', value: prefixTH })
//       )
//     }
//   },
// })

listenerMiddlewareEnroll.startListening({
  actionCreator: setFormNextButtonDisabled,
  effect: async (action, listenerApi) => {
    handleStep2Button(listenerApi)
  },
})

listenerMiddlewareEnroll.startListening({
  actionCreator: removeEnroll,
  effect: async (action, listenerApi) => {
    const { index } = action.payload
    const { enrollFormError, formNextButtonDisabled, formError } =
      listenerApi.getState().classEnroll
    let newEnrollFormError = [...enrollFormError]
    newEnrollFormError.splice(index, 1)
    listenerApi.dispatch(
      setReduxValue({
        index: 'enrollFormError',
        value: newEnrollFormError,
      })
    )
    let newFormNextButtonDisabled = [...formNextButtonDisabled]
    newFormNextButtonDisabled.splice(index, 1)
    listenerApi.dispatch(
      setReduxValue({
        index: 'formNextButtonDisabled',
        value: newFormNextButtonDisabled,
      })
    )
    let newFormError = [...formError]
    newFormError.splice(index, 1)
    listenerApi.dispatch(
      setReduxValue({
        index: 'formError',
        value: newFormError,
      })
    )
  },
})
